import { Injectable } from "@angular/core";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { HttpClient } from "@angular/common/http";
import { retry } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable()
export class DepositarioProvisionalService
  implements RequestCRUD<any, ResponseServiceModel> {
  private API_URL;

  constructor(
    private http: HttpClient,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  update(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  create(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  delete(entry: any): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  getConsultaPrestador(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/DepositarioProvisionalAdministrador/ObtenerPorCodigoRnt/${entry.codigo_rnt}`
      )
      .pipe(retry(2));
  }

  asignarUsuarioDepositario(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/DepositarioProvisionalAdministrador/Crear`,
        entry
      )
      .pipe(retry(2));
  }

  getUsuariosDepositarios(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/DepositarioProvisionalAdministrador/ObtenerDepositariosProvisionales`
      )
      .pipe(retry(2));
  }

  eliminarUsuarioDepositario(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/DepositarioProvisionalAdministrador/Eliminar`,
        entry
      )
      .pipe(retry(2));
  }
}
